import { Receipt } from 'lucide-react';
import { colors } from '../../styles/colors';

/**
 * Composant tableau des frais scannés
 *
 * @param {Array} receipts - Liste des frais à afficher
 * @param {boolean} loading - Indique si le chargement est en cours
 */
function ReceiptsTable({ receipts = [], loading = false }) {
  const styles = {
    tableContainer: {
      backgroundColor: colors.background.white,
      borderRadius: '8px',
      border: `1px solid ${colors.border.light}`,
      overflow: 'hidden',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    thead: {
      backgroundColor: colors.background.light,
      borderBottom: `2px solid ${colors.border.light}`,
    },
    th: {
      padding: '1rem',
      textAlign: 'left',
      fontSize: '0.875rem',
      fontWeight: '600',
      color: colors.text.secondary,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    td: {
      padding: '1rem',
      fontSize: '0.9375rem',
      color: colors.text.dark,
      borderBottom: `1px solid ${colors.border.light}`,
    },
    emptyState: {
      textAlign: 'center',
      padding: '3rem 2rem',
      color: colors.text.secondary,
    },
    emptyIcon: {
      marginBottom: '1rem',
      color: colors.secondary.mediumGray,
    },
    loadingState: {
      textAlign: 'center',
      padding: '3rem 2rem',
      color: colors.text.secondary,
    },
  };

  return (
    <div style={styles.tableContainer}>
      {loading ? (
        <div style={styles.loadingState}>
          <p>Chargement des frais...</p>
        </div>
      ) : receipts.length === 0 ? (
        <div style={styles.emptyState}>
          <Receipt size={48} style={styles.emptyIcon} />
          <p style={{ margin: 0, fontSize: '1.125rem', fontWeight: '500' }}>
            Aucun frais trouvé
          </p>
          <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.875rem' }}>
            Aucun frais ne correspond aux filtres sélectionnés
          </p>
        </div>
      ) : (
        <table style={styles.table}>
          <thead style={styles.thead}>
            <tr>
              <th style={styles.th}>Date</th>
              <th style={styles.th}>Fournisseur</th>
              <th style={styles.th}>Nom</th>
              <th style={styles.th}>Montant HT</th>
              <th style={styles.th}>TVA</th>
              <th style={styles.th}>Montant TTC</th>
            </tr>
          </thead>
          <tbody>
            {receipts.map((receipt, index) => (
              <tr key={receipt.id || index}>
                <td style={styles.td}>
                  {receipt.date
                    ? new Date(receipt.date).toLocaleDateString('fr-FR')
                    : '-'}
                </td>
                <td style={styles.td}>{receipt.fournisseur || '-'}</td>
                <td style={styles.td}>{receipt.nom || '-'}</td>
                <td style={styles.td}>
                  {receipt.montantHT
                    ? `${parseFloat(receipt.montantHT).toFixed(2)} €`
                    : '-'}
                </td>
                <td style={styles.td}>
                  {receipt.montantTVA
                    ? `${parseFloat(receipt.montantTVA).toFixed(2)} €`
                    : '-'}
                </td>
                <td style={{
                  ...styles.td,
                  fontWeight: '600',
                  color: colors.primary.teal
                }}>
                  {receipt.montantTTC
                    ? `${parseFloat(receipt.montantTTC).toFixed(2)} €`
                    : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ReceiptsTable;
